import { Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IHeaderProps {
  rootEntity: string;
  customTitle?: string;
  customSubtitle?: string;
}

export const Header = ({
  rootEntity,
  customTitle,
  customSubtitle,
}: IHeaderProps) => {
  const { t } = useTranslation([rootEntity, 'common']);

  return (
    <Flex pb={5} flexDir="column">
      <Text color="brand.800" fontSize="3xl" fontWeight={600}>
        {customTitle || t(`${rootEntity}:title`)}
      </Text>

      <Text fontSize="lg" color="neutral.700" fontWeight={400}>
        {customSubtitle || t(`${rootEntity}:subtitle`)}
      </Text>
    </Flex>
  );
};
